// Data tables plugin to change how many records are shown.
$.fn.dataTableExt.oApi.fnLengthChange = function ( oSettings, iDisplay )
{
    oSettings._iDisplayLength = iDisplay;
    oSettings.oApi._fnCalculateEnd( oSettings );

    /* If we have space to show extra rows (backing up from the end point - then do so */
    if ( oSettings._iDisplayEnd == oSettings.aiDisplay.length )
    {
        oSettings._iDisplayStart = oSettings._iDisplayEnd - oSettings._iDisplayLength;
        if ( oSettings._iDisplayStart < 0 )
        {
            oSettings._iDisplayStart = 0;
        }
    }

    if ( oSettings._iDisplayLength == -1 )
    {
        oSettings._iDisplayStart = 0;
    }

    oSettings.oApi._fnDraw( oSettings );

    if ( oSettings.aanFeatures.l )
    {
        $('select', oSettings.aanFeatures.l).val( iDisplay );
    }
};

Date.prototype.stdTimezoneOffset = function() {
  var jan = new Date(this.getFullYear(), 0, 1),
      jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

Date.prototype.isDST = function() {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};

// RMC JavaScript
var escapeHTML = function (raw_str) {
  return raw_str ? raw_str.replace(/&(?![#\w]+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';
};

var row_to_object = function(row) {
  var item = {};
  $(row).find(":input").each(function() {
    var $this = $(this),
        name = $this.attr("name");
    if (!name) {
      return true;
    }
    item[name.replace(/(\[\d+\])$/, '')] = ($this.attr('type') === 'checkbox')? $this.is(':checked') : $this.val();
  });
  return item;
};

var get_row_index = function(row) {
  var index = -1;
  $(row).find(":input").each(function() {
    var $this = $(this),
        name = $this.attr("name"),
        num;
    if (!name) {
      return true;
    }
    num = name.match(/\[(\d+)\]$/);
    if (num.length > 0) {
      index = num[1];
      return false;
    }
  });
  return index;
};

var create_axtooltip = function(selector, value, options) {
  options = options || {};
  var $elem = $(selector),
      tt_title = options.title,
      tt_class = options.class,
      trunc = options.trunc === undefined ? true : options.trunc,
      instant = options.instant === undefined ? false : options.instant;

  $elem.attr('data-axtooltip', value);
  $elem.attr('data-axtooltip-trunc', trunc);
  $elem.attr('data-axtooltip-instant', instant);

  if (tt_title) {
    $elem.attr('data-axtooltip-title', tt_title);
  }
  if (tt_class) {
    $elem.attr('data-axtooltip-class', tt_class);
  }
};

var create_axtable_cell_axtooltip = function(table_selector, cell_selector, options) {
  options = options || {};
  var $table = $(table_selector);
  $table.find('.trow:not(.headers-container) '+cell_selector).each(function (i, row) {
    var $row = $(row),
        content = $row.html();
    create_axtooltip($row, content, options);
  });
};

$(document).on('click', '.subsection.link-contact-support a', function(){
  show_simple_dialog("<?= lang('label_cc_contact_support'); ?>", '/dialog/failover_support');
});

var addTableRow = function(tableSelector, limit){
  var table = $(tableSelector),
      num = table.data('num');
  if(table.find('.trow').length < limit+1){
    var record = table.find('.trow:last').clone();
    record.find('input').each(function(){
      var name = this.getAttribute('name').replace(/(\[\d+\])$/, '');
      this.value = '';
      this.setAttribute('name', name + '[' + num + ']');
    });
    table.append(record).data('num', num+1);
  }
};

var addTableRowUpdated = function(addButton, tableSelector, limit){
	var table = $(tableSelector),
      num = table.data('num'),
      numRows = table.find('.js-trow').length;
	if (numRows < limit) {
		var record = table.find('.js-trow:last').clone();
		record.find('input').each(function(){
			var name = this.getAttribute('name').replace(/(\[\d+\])$/, '');
			this.value = '';
			this.setAttribute('name', name + '[' + num + ']');
		});
		table.append(record).data('num', num+1);
    if (++numRows >= limit) {
      $(addButton).hide();
    }
	}
};

var deleteTableRow = function(el, tableSelector){
  var element = $(el);
  if(element.parents(tableSelector).find('.trow').length > 2){
    element.parents('.trow').remove();
  } else{
    $(tableSelector + ' .trow input').val('');
  }
};

var deleteTableRowUpdated = function(el, tableSelector, addButtonSelector){
	var element = $(el);
	if(element.parents(tableSelector).find('.js-trow').length > 1){
		element.parents('.js-trow').remove();
	} else{
		$(tableSelector + ' .js-trow input').val('');
	}
  $(addButtonSelector).show();
};

/**
 * keep the session alive while the page is in use; check the server periodically for session changes
 * warn if the session is nearly expired
 * redirect if the user becomes logged in or out
 */
var session_manager = new function () {
  var this_sm       = this;
  this.interval     = 2 * 60; // ping and knock intervals
  this.lifetime     = 4 * 60 * 60; // session ttl; must match the value on the backend
  this.warn_after  = this.lifetime - 5 * 60; // delay in showing the auto logout dialog before the actual logout
  this.last_click   = null;
  this.last_ping    = null;
  this.logout_timer = null;
  this.logout_after = 60000;
  this.now          = function(){
                        return Math.floor((new Date()).getTime() / 1000);
                      };
  this.start        = function(){
                        // construct
                        this_sm.last_click = this_sm.now();
                        this_sm.last_ping = this_sm.now();
                        $(document).ajaxSuccess(function (e, xhr, settings){
                          if (settings.url !== '/session/pong' && settings.url.indexOf('/notification/check_notifications') === -1) {
                            this_sm.last_ping = this_sm.now();
                          }
                        });
                        $(document).click(function () {
                          this_sm.persist();
                        });
                        $(document).on('dialogclose', function () {
                          this_sm.persist();
                        });
                        setInterval(this_sm.maintenance, this_sm.interval * 1000);
                      };
  this.persist      = function(){
                        // any action should call this function to schedule a server ping
                        this_sm.last_click = this_sm.now();
                        this_sm.warning();
                      };
  this.logout       = function(lastClick) {
                        if (lastClick == this_sm.last_click) {
                          $.get('/session/force_logout');
                          clearTimeout(this_sm.logout_timer);
                        }
                      };
  this.init_logout  = function() {
                        var $logoutDlg = $('#logout_dlg');
                        var lastClick = this_sm.last_click;
                        if ($logoutDlg.dialog('instance') !== undefined) {
                          this_sm.logout_timer = setTimeout(this_sm.logout.bind(null, lastClick), this_sm.logout_after);
                        }
                      };
  // this is the public maintenance function that should be used
  this.maintenance  = function(){
                        this_sm._maintenance(false);
                      };
  this._maintenance = function(prevent_extra_calls){
                        // this runs every minute or so to make sure the server is hit frequently
                        // ping the server to keep the session alive
                        if (this_sm.last_click > this_sm.last_ping){
                          $.get('/session/ping');
                        }
                        // get the ping time from the server in case there are multiple tabs / windows open
                        else {
                          $.get('/session/pong', function (data){
                            var lp = parseInt(data);
                            this_sm.last_ping = Math.max(this_sm.last_ping, this_sm.now() - lp);
                            this_sm.warning();
                            // deal with slow interval rate
                            if (!prevent_extra_calls) {
                              var _now = this_sm.now();
                              var _next = _now + this_sm.interval;
                              var warn = this_sm.last_ping + this_sm.warn_after;
                              var logout = this_sm.last_ping + this_sm.lifetime;
                              // schedule an extra pong for right before and after we think the session will expire
                              if (_now < logout - 5 && logout - 5 < _next){
                                setTimeout(this_sm.m_oneoff, (logout - 5 - _now) * 1000);
                              }
                              if (_now < logout + 2 && logout + 2 < _next){
                                setTimeout(this_sm.m_oneoff, (logout + 2 - _now) * 1000);
                              }
                              // schedule an extra pong for right before and after we think the warning dialog should be shown
                              if (_now < warn - 5 && warn - 5 < _next){
                                setTimeout(this_sm.m_oneoff, (warn - 5 - _now) * 1000);
                              }
                              if (_now < warn + 2 && warn + 2 < _next){
                                setTimeout(this_sm.m_oneoff, (warn + 2 - _now) * 1000);
                              }
                            }
                          });
                        }
                      };
  this.m_oneoff     = function(){
                        this_sm._maintenance(true);
                      };
  this.knock        = function(){
                        // this is the equivalent of maintenance() in that it is called every minute or so; it is only for the login page
                        // assume the user is logged out; redirect if the user becomes logged in
                        $.get('/session/knock', function (data){
                          if (data != ''){
                            document.location.href = '/';
                          }
                        });
                      };
  this.warning      = function(){
                        // open or close the auto logout dialog as necessary
                        var $logoutDlg = $('#logout_dlg'),
                            open = ($logoutDlg.dialog('instance') !== undefined),
                            shouldOpen = (this_sm.now() - Math.max(this_sm.last_ping, this_sm.last_click) > this_sm.warn_after);
                        if (open && !shouldOpen){
                          this_sm.hide_warning();
                        }
                        if (!open && shouldOpen){
                          this_sm.show_warning();
                          this_sm.init_logout();
                        }
                        return shouldOpen;
                      };
  this.show_warning = function (){
                        $('#logout_dlg').dialog({
                        	dialogClass : 'axDialog',
                          autoOpen  : true,
                          closeText : _close_label,
                          draggable : false,
                          minWidth  : '300',
                          modal     : true,
                          resizable : false,
                          title     : logout_dialog_title,
                          width     : '600',
                          buttons   : [{ text: _logout_label, click: this_sm.m_oneoff, class: 'btn btn-primary single-button' }]
                          });
                      };
  this.hide_warning = function (){
                        $('#logout_dlg').dialog('destroy');
                      };

  $(document).ready(function(){
    if (typeof handleLogin == 'undefined'){
      this_sm.start();
    } else {
      setInterval(this_sm.knock, this_sm.interval * 1000);
    }
  });
};

function legacytrpopout(e){
  var $this = $(this), $trow = $this.closest('.trow');
  killgenericpopout();
  if(!$this.hasClass('activerow')){
    $this.addClass('activerow');
		var ytarget = ($trow.position().top + $trow.outerHeight()),
		$popout = $this.find('.popout');
		$popout.css({ 'top' : ytarget, 'right' : 0 });
    $popout.show();
  }

  e.stopPropagation();
}

var createStorageDonut = function(params, elementId){
  google.charts.load("current", {packages:["corechart"]});
  google.charts.setOnLoadCallback(drawPieChart);
  var dataArray = [['index', 'value']],
      dataColors = [];
  $.each(params, function(index, value){
    dataArray.push([index, value]);
    dataColors.push(index);
  });

  function drawPieChart() {
    var data = google.visualization.arrayToDataTable(dataArray),
        el = document.getElementById(elementId),
        options = {
      legend: 'none',
      pieSliceText: 'none',
      enableInteractivity: false,
      tooltip: {trigger: 'none'},
      pieHole: 0.5,
      width: el.width,
      height: el.height,
      colors: dataColors,
      chartArea: {
        width: '100%',
        height: '100%'
      }
    };
    var chart = new google.visualization.PieChart(el);
    chart.draw(data, options);
  }
};

var createStorageBargraph = function(appId, elementId){
  google.charts.load("current", {packages:["corechart"]});
  google.charts.setOnLoadCallback(drawBarChart);

  function drawBarChart(){
    var el = document.getElementById(elementId),
        options = {
      width: el.width,
      height: el.height,
      legend: { position: 'none' },
      tooltip: { trigger: 'none' },
      enableInteractivity: false,
      bar: {
        groupWidth: 20
      },
      vAxis: {
        ticks: [0, 0.5, 1],
        baselineColor: 'transparent',
        format: '#,###%'
      },
      hAxis: {
        gridlines: {color: 'transparent'},
        baselineColor: 'transparent',
        textPosition: 'none'
      },
      series: {
        0: {
          targetAxisIndex: 1,
          color: '9cbec8',
        }
      },
      chartArea: {
        width: '100%',
        height: '90%',
        right: 35
      }
    };
    $.ajax({
      url: '/appliance/details_bar_graph/' + appId,
      type: 'GET',
      dataType: 'json',
      success: function(rv){
        var dataArray = [['index', 'value']];
        rv.forEach(function(value, index){
          dataArray.push([index, value]);
        });
        var data = google.visualization.arrayToDataTable(dataArray),
            view = new google.visualization.DataView(data),
            chart = new google.visualization.ColumnChart(el);
        chart.draw(view, options);
      }
    });
  }
};

function addDialogIcon(dialog, options) {
	dialog.data("uiDialog")._title = function (title) {
		title.parent().prepend('<i class="fa fa-exclamation-triangle error-icon mr-2" aria-hidden="true"></i>');
		title.text(this.options.title);
	};

	dialog.dialog('option', 'title', options.title);
}

var show_alert = function (title, text, display_options){
	var dlg = $('#message_box');
  if (dlg.length > 0){
    dlg.remove();
  }

  var $dialog = $('<div id="message_box" style="display:none;"></div>')
      .html(text);
	$('#content').after($dialog);

  var options = {
    dialogClass : 'axDialog',
    autoOpen  : true,
    closeText : _close_label,
    draggable : false,
    minWidth  : '500',
    modal     : true,
    resizable : false,
    title     : title,
    width     : '700',
    close     : function(){
      $dialog.dialog('destroy').remove();
      $('.js-modal-mfa-box').show();
    },
    buttons   : [{
      text: _close_label,
      class: "single-button",
      click: function(){
        $dialog.dialog('destroy').remove();
        $('.js-modal-mfa-box').show();
      }
    }]
  };

  for (var i in display_options){
    options[i] = display_options[i];
  }

	$dialog.dialog(options);
	addDialogIcon($dialog, options);

  $('.close_dialog').click(function(){
		$dialog.dialog('destroy').remove();
  });
};

var show_alert_ajax = function (title, url, display_options){
	var dlg = $('#message_box');
  if (dlg.length > 0){
    dlg.remove();
  }

  var $dialog = $('<div id="message_box" style="display:none;"></div>');
  $('#content').after($dialog);
  var options = {
    dialogClass : 'axDialog',
    autoOpen  : false,
    closeText : _close_label,
    draggable : false,
    minWidth  : '500',
    minHeight : '200',
    modal     : true,
    resizable : false,
    title     : title,
    width     : '700',
    close     : function(){ $dialog.dialog('destroy').remove(); },
    buttons   : [{
      text: _close_label,
      click: function(){ $dialog.dialog('destroy').remove(); }
    }]
  };
  for (var i in display_options){
    options[i] = display_options[i];
  }
  var deferred = $.Deferred().done(function(){
    $dialog.dialog(options);
    $dialog.dialog('open');
  });

  $dialog.load(
      url,
      function(){ deferred.resolve(); }
  );
  return deferred;
};

var show_alert_2 = function (title, text){
  var e = $('axdialog[dialogname="showAlert"]');
  e.find('.modaltitle').text(title);
  e.find('.subheader').text(title);
  e.find('.support-text').text(text);
  angular.element(e[0]).scope().toggleDialog();
};

var show_info = function (title, header, text){
  var e = $('axdialog[dialogname="showAlert"]');
  e.find('.modaltitle').text(title);
  e.find('.subheader').text(header);
  e.find('.support-text').html(text);
  angular.element(e[0]).scope().toggleDialog();
};

var show_error = function (header, text){
  var e = $('axdialog[dialogname="showError"]');
  e.find('.modaltitle').text(_error_label);
  e.find('.subheader').text(header);
  e.find('.support-text').html(text);
  angular.element(e[0]).scope().toggleDialog();
};

var show_loading = function (message, display_options){
  var dlg = $('#loading_box');
  if (dlg.length > 0){
    dlg.remove();
  }

  var div = $('<div>')
    .css('text-align', 'center')
    .css('margin-top', '20px')
    .html(message);
  var img = $('<img>')
    .attr('src', '/images/ajax-loader-squares.gif')
    .css('display', 'block')
    .css('margin', '10px auto 0 auto')
    .css('opacity', '0')
    .delay(1000)
    .animate({opacity: 1}, 3000);
  var $loadingBox = $('<div id="loading_box" style="display:none;"></div>');
  $('#content').after($loadingBox);

  var options = {
    dialogClass : 'axDialog',
    autoOpen  : true,
    closeText : _close_label,
    draggable : false,
    minWidth  : '500',
    modal     : true,
    resizable : false,
    title     : _loading_label,
    width     : '700',
    open      : function() { $(".ui-dialog-titlebar-close").hide(); },
    close     : function(){ $loadingBox.dialog('destroy').remove(); },
    buttons   : [],
    closeOnEscape: false
  };
  for (var i in display_options){
    options[i] = display_options[i];
  }

  $loadingBox.append(div);
  $loadingBox.append(img);
  $loadingBox.dialog(options);
};

/*
 * Create a Feedback dialog
 */
var show_feedback_dialog = function(){
  var $dialog = $('#feedback_dlg');
  $dialog.dialog({
		dialogClass : 'axDialog dialog',
		autoOpen  : true,
		closeText : _close_label,
		draggable : false,
		minWidth  : '500',
		modal     : true,
		resizable : false,
		title     : _feedback_dialog_title,
		width     : '700',
		close     : function(){$dialog.dialog('destroy');},
		buttons   : [
			{
			 text: _cancel_label,
			 click: function(){$dialog.dialog('destroy');}
			},
      {
			 text: _feedback_label,
			 click: send_feedback
			}
    ]
	});
};

var send_feedback = function(){
  $.ajax({
    type:     "POST",
    url:      "/rmc/feedback",
		dataType: 'json',
    data:     {
    	feedback : $('#feedback_dlg [name=feedback]').val()
    },
    success: function(rv){
			if (rv['is_error']){
				//populate validation errors
				//TODO - do something if there is an error
			}
			else {
				//do to the nature of the effects implementation, need to chain these
				//as callback functions for each object effect
				$('#feedback_content').fadeOut(400, function(){
					$('#feedback_success').fadeIn(400, function(){
						$('#feedback_dlg').delay(1500).fadeOut(400, function(){
							$('#feedback_dlg').dialog('destroy');
							$('#feedback_success').hide();
							$('#feedback_content').show();
						});
					});
				});
			}
    }
  });
};

var showValidationMessages = function (fieldMessages, typeName, messageType) {
  var headerClass, spanPrefix;
  if(messageType === 'warning'){
    headerClass = '.warning_header';
    spanPrefix = '#warn_';
  } else {
    headerClass = '.error_header';
    spanPrefix = '#err_';
  }
  for(fieldKey in fieldMessages){
    var errMsg = fieldMessages[fieldKey],
        errSpan = $(spanPrefix + typeName + '_' + fieldKey);
    errSpan.html(errMsg);
    errSpan.show();
  }
  $('#'+typeName+'_edit div' + headerClass).show();
};

var clear_errors = function(_type){
  $('.error_msg')
      .text('')
      .hide();
	$('#'+_type+'_edit div.error_header').hide();
};

var _menu_failover_click = function(e){
  if (0 >= this.dataset.clientId) {
    _error_dlg(err_appliance_no_client);
    return;
  }

  var appliance_id = this.getAttribute('_id');

  killgenericpopout();
  $.getScript('/appliance/appliance_failover_script/' + appliance_id);
  e.stopPropagation();
};

var _menu_detail_click = function(e){
	killgenericpopout();
	if (typeof(e.data.fnDetails) == 'undefined'){
		_error_dlg(err_operation_failed);
	}
	else {
		e.data.fnDetails(this);
	}
	e.stopPropagation();
};

var _menu_detail_click_id = function(e){
	killgenericpopout();
	if (typeof(e.data.fnDetails) == 'undefined'){
		_error_dlg(err_operation_failed);
	}
	else {
		e.data.fnDetails(this.getAttribute('_id'));
	}
	e.stopPropagation();
};

var _menu_edit_click = function(e){
	killgenericpopout();
	if (typeof(e.data.entityType) == 'undefined'){
		_error_dlg(err_operation_failed);
	}
	else {
		_object_edit_handler(this, e.data.entityType);
	}
	e.stopPropagation();
};

var _menu_delete_click = function(e){
	killgenericpopout();
	if (typeof(e.data.entityType) == 'undefined'){
		_error_dlg(err_operation_failed);
	}
	else {
		_object_delete_handler({id: this, type: e.data.entityType});
	}
	e.stopPropagation();
};

var _manage_office_click = function(clientId, alwaysGoToOfficePage = false) {
  killgenericpopout();
  $.getScript('/client/client_failover_script/' + clientId + '/true/' + alwaysGoToOfficePage);
}

/*
 * Generic edit handler for the entity lists. Will look
 * for a specific edit_handler for the entity type, and will delegate
 */
var _object_edit_handler = function(el, _type){
	if (window[_type + '_edit_handler']){
		return window[_type + '_edit_handler'](el);
	}

	var id = el.getAttribute('_id'),
      listId =  $(el).data('listId');
	_object_edit({id: id, type: _type, listId: listId});
};

/*
 * data.id - required id for the object of type to be edited
 * data.type - required entity type
 * data.listId - optional listId for legacy
 */
var _object_edit = function(data){
	var deferred = _object_get(data.type, data.id);
	deferred.done(function(arg){
		//Look for a list id that needs to be refreshed post save on the new link
		if (typeof(data.listId) != 'undefined'){
			//FIXME - come up with a better mechanism for addressing the list to be updated.
			$('#' + data.type + '_edit').data('listId', data.listId);
		}
	});
};



/*
 * Generic handler for deleting an entity. Fetches the appropriate
 * identifier and confirms with the user that they want to delete
 * that record. Another method handles the actual delete.
 * args.id - required id for the object of type to be deleted
 * args.type - required entity type
 */
var _object_delete_handler = function(args){
	var id = isNaN(args.id) ? args.id.getAttribute('_id') : args.id,
      $dialog = $('<div id="delete_dlg" style="display:none;"></div>');
	$('#content').after($dialog);
  $dialog.load(
			'/' + args.type + '/load_delete_view/' + id,
			function(response){
        var isDeleted = $(response).is('.access_denied_container'),
            listId = $(args.id).data('listId');
        if(isDeleted){
          if(listId != undefined){
            $('#'+listId).dataTable().fnDraw();
          }
        } else {
          var dlg_title = $('#delete_container').attr('_dialog_title');
          _object_delete_dlg_init({
            type: args.type,
            id: id,
            title: dlg_title,
            actionLabel: args.actionLabel
          });

          //Look for a list id that needs to be refreshed post save on the new link
          if (listId != undefined){
            //FIXME - come up with a better mechanism for addressing the list to be updated.
            $dialog.data('listId', listId);
          }
        }
			}
	);
};

/*
 * Performs the actual delete call for the object in question
 * args.id - required id for the object of type to be deleted
 * args.type - required entity type
 */
var _object_delete = function(args){
  $('#delete_dlg .error_header').hide();
  $('.ui-dialog-buttonset').children(':first').addClass('disabled');
	$.ajax({
		url: '/api/v1/object/' + args.type + '/delete/' + args.id,
		type: 'DELETE',
		dataType: 'json',
		error: function(req, textStatus, errorThrown){
			alert("An error occurred status=" + textStatus);
		},
		success: function(rv){
      if (rv['is_error']) {
        $('#delete_dlg .error_msg').text(rv['message']).show();
        $('#delete_dlg .error_header').show();
        $('#delete_confirm').hide();
        var $buttonsSet = $('.ui-dialog-buttonset');
        $buttonsSet.children(':first').off().hide();
        $buttonsSet.children(':last').children(':first').html(_close_label);
      } else {
				if (window[args.type + '_delete_success']){
					if (window[args.type + '_delete_success'](rv)){
						//If the success over-ride wants to head off
						//any further processing, return true. Otherwise false
						return;
					}
				}

				//Allow the data table ID to be stored on the delete dlg
				var list_id = $('#delete_dlg').data('listId');
				if (list_id == undefined){
					list_id = args.type+'_list';
				}
				_object_delete_dlg_destroy();
        var list = document.getElementById(list_id);
				if (list){
					//There is a chance that the edit / save was not invoked from the entities list page
					$(list).dataTable().fnDraw();
				}

				$(document).trigger('delete.' + args.type, [args.id]);
			}
		}
	});
};

var _object_delete_dlg_init = function(args){
	$('#delete_dlg').dialog({
		dialogClass : 'axDialog',
		autoOpen  : true,
		closeText : _close_label,
		draggable : false,
		minWidth  : '500',
		modal     : true,
		resizable : false,
		title     : args.title,
    width     : '700',
		close     : _object_delete_dlg_destroy,
    buttons: [
      {
        text: _cancel_label,
        click: _object_delete_dlg_destroy
      },
      {
        text: args.actionLabel || _delete_label,
        click: function () {
          _object_delete({
            id: args.id,
            type: args.type
          });
        }
      }
    ]
  });
};

var _object_delete_dlg_destroy = function(){
	$('#delete_dlg').dialog('destroy').remove();
};

//Alter the href on the link for the download. need to include the search value
var _object_download_handler = function(controller, table_id, el){
	var url = '/'+ controller +'/download/' + $.base64urlEncode($('#' + table_id + '_filter input').val());
	el.setAttribute('href', url);
	return true;
};


/**
 * _object_table_init expects certain conventions on the table that is being initialized. The id attribute of the
 * table must be <object_type>_list. This function also expects that there will be
 * @returns
 */
var _object_table_init = function (_type, num_cols, show_details, show_edit, show_delete, show_support) {
  //Overrides to default entity behavior
  var entity_type = (typeof (_type.type) == "undefined") ? _type : _type.type,
      list_id = (typeof (_type.list_id) == "undefined") ? entity_type + '_list' : _type.list_id,
      ajax_call = (typeof (_type.ajax_call) == "undefined") ? '/' + entity_type + '/data' : _type.ajax_call,
      action_col_idx = entity_type === 'reseller' ? num_cols - 2 : num_cols - 1,
      default_col_rndr = function (val, type, row) {
    var actions = '',
        checkEditByType = function () {
      switch (entity_type) {
        case 'reseller':
          return row[action_col_idx + 1];
        default:
          return true;
      }
    };
    var checkDeleteByType = function () {
      switch (entity_type) {
        case 'reseller':
          return row[action_col_idx + 2];
        default:
          return true;
      }
    };
    if (show_edit || show_delete || show_details || show_support) {
      actions = '<div class="col-action-container"><div class="col-actions">&nbsp;</div><div class="popout" style="display: none;"><ul>';
      if (show_edit && checkEditByType()) {
        actions += '<li class="popoutitem"><div class="' + entity_type + '_edit action" data-list-id="' + list_id + '" _id="' + row[action_col_idx] + '">' + _edit_label + '</div></li>';
      }
      if (show_details) {
        actions += '<li class="popoutitem"><div class="' + entity_type + '_details action" _id="' + row[action_col_idx] + '" _lbl="' + row[0] + '">' + _details_label + '</div></li>';
      }
      if (show_support) {
        actions += '<li class="popoutitem"><div class="' + entity_type + '_support action" _id="' + row[action_col_idx] + '" _lbl="' + row[0] + '">' + _support_label + '</div></li>';
      }
      if (show_delete && checkDeleteByType()) {
        actions += '<li class="popoutitem"><div class="' + entity_type + '_delete action" data-list-id="' + list_id + '" _id="' + row[action_col_idx] + '">' + _delete_label + '</div></li>';
      }
      actions += "</ul></div></div>";
    }
    return actions;
  };
  var action_col_rndr = (typeof (_type.action_col_rndr) == "undefined") ? default_col_rndr : _type.action_col_rndr;

	return $(`#${list_id}`).dataTable({
		"bServerSide": true,
		"bProcessing": true,
		"sAjaxSource": ajax_call,
		"bJQueryUI": true,
		"bStateSave": true,
		"sPaginationType": "full_numbers",
    autoWidth: false,
    columnDefs: [{
        render: action_col_rndr,
        sortable: false,
        width: '80px',
        class: 'actions',
        targets: [action_col_idx]
      },
      {
        width : 'auto',
        targets: '_all'
      }],
		"fnServerData": function (sSource, aoData, fnCallback) {
			$.ajax({
				'dataType': 'json',
				'type': 'POST',
				'url': sSource,
				'data': aoData,
				'success': fnCallback
			});
		},
		"fnInitComplete": function (oSettings, json) {
			$('.dataTables_filter input').attr('maxlength', 128);
		},
		"fnDrawCallback": function (oSettings) {
      var $this = $(this);
			$this.find('tr').click(legacytrpopout);

			if (show_edit) {
				$this.find('.' + entity_type + '_edit').on('click', {entityType: entity_type}, _menu_edit_click);
			}
			if (show_delete) {
				$this.find('.' + entity_type + '_delete').on('click', {entityType: entity_type}, _menu_delete_click);
			}
			if (show_details) {
				$this.find('.' + entity_type + '_details').on('click', {fnDetails: window['_view_' + entity_type + '_details']}, _menu_detail_click);
			}
		},
		"createdRow": function (row, data, dataIndex, cells) {
			row.classList.add('trow');
			for (var i = 0; i < cells.length; i++) {
				if (i !== action_col_idx) {
					cells[i].classList.add('multiline');
				}
			}
		}
	});
};

var add_custom_buttons = function(_type) {
  if (_type === 'user') {
    return [
			{
				text: _cancel_label,
				class: 'js-cancel-user-edit',
				click: function () {_object_edit_dlg_destroy(_type);}
			},
			{
        text: _ok_label,
        class: 'js-ok-user-edit invisible',
        click: function () {_object_edit_dlg_destroy(_type);}
      },
			{
				text: _save_label,
				class: 'js-save-user-edit'
			}
		];
  } else if (_type === 'reseller') {
    return [
      {
        text: _cancel_label,
        class: 'js-cancel-reseller-edit',
        click: function () {_object_edit_dlg_destroy(_type);}
      },
      {
        text: _save_label,
        class: 'js-save-reseller-edit'
      }
    ];
  }
  var objLiteral = {
    notification: function() {
      return {
              text: _complete_label,
              class: 'complete invisible',
              click: function(e){
                var completeButton = e.currentTarget;
                $(completeButton).data('custom_action', 'complete');
                if (!completeButton.classList.contains('disabled')) {
                  completeButton.classList.add('disabled');
                  _object_save(_type, completeButton);
                }
              }
            }
    }
  };
  if (objLiteral.hasOwnProperty(_type)) {
    return objLiteral[_type]();
  }
}

var _object_edit_init = function(_type, title){

	var buttons = [
		{
			text: _cancel_label,
			click: function () {
				_object_edit_dlg_destroy(_type);
			}
		},
		{
			text: _save_label,
      class: 'btn-dialog-save',
			click: function (e) {
				var saveButton = e.currentTarget;
				if (!saveButton.classList.contains('disabled')) {
          saveButton.classList.add('disabled');
					_object_save(_type, saveButton);
				}
			}
		}
	]

  var customButtons = add_custom_buttons(_type);
  if (_type === 'user' || _type === 'reseller') {
    buttons = customButtons
  } else if (customButtons) {
    buttons.splice(1, 0, customButtons);
  }
	$('#'+_type+'_edit_dlg').dialog({
		autoOpen  : false,
		dialogClass : 'axDialog',
		closeText : _close_label,
		draggable : false,
		minWidth  : '574',
		minHeight : '350',
		modal     : true,
		resizable : false,
		title     : title,
		width     : '700',
		close     : function(event, ui){
			_object_edit_dlg_destroy(_type);
		},
		buttons : buttons
		});
};

var _object_edit_dlg_destroy = function(_type){
	$('#'+_type+'_edit_dlg').dialog('destroy').remove();
};


var _object_save = function(_type, saveButton){
	//Inline Validation check.
  var $form = $("form#" + _type + "_edit_form.inl_validate");
	if($form.length === 1 && !$form.valid()) {
    $(saveButton).removeClass('disabled');
    return;
  }
	//Inline Validation check.

	//If an over-ride exists, then delegate
	if (window[_type + '_save']){
		return window[_type + '_save']();
	}

	clear_errors(_type);

	var fields = window[_type+'_fields'],
      data = {};
	for(var i=0; i < fields.length; i++){
		var fld = fields[i];

		var el = $('#'+_type+'_edit [name="' + fld + '"]');
		// handle checkbox arrays
		if (fld.substring(fld.length - 2, fld.length) == "[]"){
		  var fld_data = [];
		  $('#'+_type+'_edit [name="' + fld + '"]:checked').each(function(idx, el){
		    fld_data.push($(this).val());
		  });
		  data[fld] = fld_data;
		}
		else if (el){
			if (el.attr('type') === 'checkbox'){ // handle checkboxes
				if (el.is(':checked')){
					data[fld] = 1;
				}
				else {
					//don't send a value if not set.
					data[fld] = 0;
				}
			}
			else if (el.attr('type') === 'radio') { // handle radiobuttons
			  data[fld] = $('#'+_type+'_edit [name="' + fld + '"]:checked').val();
			}
			else {
				data[fld] = el.val();
			}
		}
	}

  // If the button is a custom one, get a custom action and update the data
  data.custom_action = $(saveButton).data("custom_action");

  $(document).trigger('save_before_send.' + _type);
	$.ajax({
		url: '/api/v1/object/'+_type+'/save/',
		type: 'POST',
		dataType: 'json',
		data: data,
		error: function(req, textStatus, errorThrown){
			alert("An error occurred status=" + textStatus);
		},
		success: function(rv){
			if (rv['is_error']){
				//populate validation errors
        $(saveButton).removeClass('disabled');
				showValidationMessages(rv['errors'], _type);
        $(document).trigger('save_error.' + _type);
			}
			else {
				if (window[_type + '_save_success']){
					if (window[_type + '_save_success'](rv)){
						//If the success over-ride wants to head off
						//any further processing, return true. Otherwise false
						return;
					}
				}
				//Allow the data table ID to be stored on the edit dlg
				var list_id = $('#'+_type+'_edit').data('listId');
				if (list_id == undefined){
					list_id = _type+'_list';
				}

				_object_edit_dlg_destroy(_type);
        var list = document.getElementById(list_id);
				if (list){
					//There is a chance that the edit / save was not invoked from the entities list page
					$(list).dataTable().fnDraw();
				}

				// trigger event for tables of selected _type
				$(document).trigger('save.' + _type);
			}
		}
	});
};

/*
 * Loads the edit dialog, with HTML returned from the server.
 */
var _object_new = function(event, _type){
  //FIXME - Make the New Dialog use the correct title
	var deferred = _object_get(_type, '');

	//Using Deferred because the actions of _object_get might not be done when it returns
	deferred.done(function(arg){
		//FIXME - come up with a better mechanism for addressing the list to be updated.
		//Look for a list id that needs to be refreshed post save on the new link
		var listId = $(event.target).data('listId');
		if (listId != undefined){
			$('#'+_type+'_edit').data('listId', listId);
		}
	});
};

/*
 * Loads the edit dialog, populated with data from the server.
 * Expects to get an HTML fragment that it can load into the dialog.
 */
var _object_get = function (_type, id, func) {
  if (typeof (func) == 'undefined') {
    func = 'load_edit_view';
  }

  // Instantiate the dialog div
  var deferred = make_deferred_dialog(_type)

  // Load the edit html if not on the page
  $('#' + _type + '_edit_dlg').load('/' + _type + '/' + func + '/' + id, function (response, status, xhr) {
    handle_edit_dlg_load_result(status, deferred);
  });
  return deferred;
};

var _remove_existing_edit_dlg = function (type) {
  //TODO - look for an over-ride hook
  var dlg = $('#' + type + '_edit_dlg');
  if (dlg.length > 0) {
    dlg.remove();
  }
};

var make_deferred_dialog = function (type) {
  //If for some reason the dlg already exists, remove it
  _remove_existing_edit_dlg(type);
  $('#content').after('<div id="' + type + '_edit_dlg" style="display:none;"></div>');
  return $.Deferred().done(function (arg) {
    var dlg_title = $('#' + type + '_edit').attr('_dialog_title');
    _object_edit_init(type, dlg_title);
    $('#' + type + '_edit_dlg').dialog('open');
  });
};

var handle_edit_dlg_load_result = function (status, deferred) {
  if (status === "error") {
    _error_dlg(err_operation_failed);
  } else {
    deferred.resolve();
  }
};

/*
 * Loads the User edit dialog so user can edit their own info.
 */
var _edit_my_account = function(){
	return _object_get('user', '', 'load_my_account');
};



/**
 * Generic method for setting the form field values on the form from data passed
 * in. Loops through the fields by name, and looks for data based on the field name
 * in the data array. If the data isn't there, then the form field value is reset.
 *
 * Can over-ride the generic functionality either before it is processed, or add to
 * it afterwards, by using a function naming convention of
 *
 * <object_type>_set_fields(fields, data, before_processing)
 *
 * The function will be called twice, once before any processing has occurred. If it
 * returns true, then the processing has been handled and the generic processing will not occur.
 *
 * @param _type
 * @param fields
 * @param data
 * @returns
 */
var _object_set_fields = function(_type, fields, data){
	var hook = false;
	if (window[_type + '_set_fields']){
		hook = true;

		//If the over-ride function returns true, the it handled the entire set.
		if ( window[_type + '_set_fields'](fields, data, true) ){
			return;
		}
	}
	for(var i=0; i < fields.length; i++){
		var fld = fields[i],
        val = data[fld];

		//TODO - test against IE
		if (!val){
			val = '';
		}
		var el = $('#'+_type+'_edit [name="' + fld + '"]');
		if (el){
			if (el.attr('type') === 'checkbox'){
				if ((val === 1) || (val === true) || (val == 'true')){
					el.prop('checked', true);
				}
				else {
					el.prop('checked', false);
				}
			}
			el.val(val);
		}
	}
	if (hook){
		window[_type + '_set_fields'](fields, data, false);
	}
};

var _view_appliance_details = function(id){
  tabs_goto('/appliance/details/' + id, 'li.clients-tab');
};

var _view_appliance_client = function(el){
  var client_id = el.dataset.clientId;
  if (client_id <= 0) {
    _error_dlg(err_appliance_no_client);
  }
  else {
    tabs_goto('client/details/' + client_id, 'li.clients-tab');
  }
};


var _view_reseller_details = function(el){
  var id = el.getAttribute('_id');
  tabs_goto('/reseller/details/' + id);
};

var _view_failover_details = function(id){
  //Reload the Clients tab
  tabs_goto('client/details/' + id + '/1', 'li.clients-tab');
};

var _view_auditor_details = function(el){
  var $dialog = $('<div id="auditor_details" style="display:none; padding-bottom: 0;"></div>'),
      id = el.getAttribute('_id');

  $('#content').after($dialog);
  $dialog.load(
      '/reports/auditor_details/' + id,
      function(){
        $dialog.dialog({
          autoOpen  : false,
          dialogClass : 'axDialog dialog',
          closeText : _close_label,
          draggable : false,
          minWidth  : '600',
          minHeight : '350',
          modal     : true,
          resizable : false,
          title     : auditor_details_label,
          width     : '700',
          close     : function(){
            $dialog.dialog('destroy').remove();
          },
          buttons   : [{
                        text: _close_label,
                        click: function(){
                          $dialog.dialog('close');
                        }
                      }]
        });
        $dialog.dialog('open');
      }
  );
};

var _view_client_details = function(el){
  var id = el.getAttribute('_id');
  tabs_goto('client/details/' + id);
};

var _view_notification_queue_details = function(el) {
  var $dialog = $('<div id="notification_queue_details" style="display:none; padding-bottom: 0;"></div>');
      id = el.getAttribute('_id');
  $('#content').after($dialog);

  $dialog.load(
      '/notification_queue/details/' + id,
      function(){
        $dialog.dialog({
          autoOpen  : false,
          dialogClass : 'axDialog dialog',
          closeText : _close_label,
          draggable : false,
          minWidth  : '600',
          minHeight : '350',
          modal     : true,
          resizable : false,
          title     : _notification_details_title,
          width     : '700',
          close     : function(){
            $dialog.dialog('destroy').remove();
          },
          buttons   : [{
                        text: _close_label,
                        click: function(){
                          $dialog.dialog('close');
                        }
                      }]
        });
        $dialog.dialog('open');
      }
  );
};

var _view_notification_details = function(el){
  var $dialog = $('<div id="notification_details" style="display:none; padding-bottom: 0;"></div>'),
      id = el.getAttribute('_id');
  $('#content').after($dialog);
  $dialog.load(
      '/notification/details/' + id,
      function(){
        $dialog.dialog({
          autoOpen  : false,
          dialogClass : 'axDialog dialog',
          closeText : _close_label,
          draggable : false,
          minWidth  : '600',
          minHeight : '350',
          modal     : true,
          resizable : false,
          title     : _notification_details_title,
          width     : '700',
          close     : function(){
            $dialog.dialog('destroy').remove();
          },
          buttons   : [{
                        text: _close_label,
                        click: function(){
                          $dialog.dialog('close');
                        }
                      }]
        });
        $dialog.dialog('open');
      }
  );
};

var _view_appliance_login = function(el){
  window.open('/appliance/login/' + el.getAttribute('_srv_id'));
};

var openRebootDialog = function(el){
  rebootApplianceDialog(el.getAttribute('_id'), el.getAttribute('_name'));
};

var refresh_handler = function(e){
	//FIXME - MAKE WORK FOR F5
	//Ctrl r, or command r
	if (((e.which === 114) && e.ctrlKey)
			|| ((e.which === 114) && e.metaKey)){
		var the_tabs = $('#tabs'),
        sel_tab = the_tabs.tabs('option', 'active');
		the_tabs.tabs('load', sel_tab);
		e.stopPropagation();
		return false;
	}
};

var appliance_delete_success = function(){
	//redraw the dashboard page in addition to the appliance list page.
  var dashboard = document.getElementById('dashboard_list');
	if (dashboard){
		$(dashboard).dataTable().fnDraw();
	}

	return false;
};

var _encode_date = function(slash_date, empty_ret_val){
	return slash_date && slash_date.length
      ? slash_date.replace(/([0-9]*)\/([0-9]*)\/([0-9]*)/,"$3-$1-$2")
      : empty_ret_val;
};

//Generalized function for saving a report definition. Takes in the query_params specific to the report type, and the type
var save_report_definition = function(query, type){
	const dlg = document.getElementById('report_definition_edit_dlg');
	if (dlg){
		//If for some reason the dlg already exists, remove it
		dlg.remove();
	}

	//instantiate the dialog div and load the edit html if not on the page.
  const $dialog = $('<div id="report_definition_edit_dlg" style="display:none;"></div>');
	$('#content').after($dialog);
	$dialog.load(
			'/report_definition/load_edit_view/0/' + type,
			() => {
				const dlg_title = $('#report_definition_edit').attr('_dialog_title');
				$('#report_definition_edit :input[name=type]').val(type);
				$('#report_definition_edit :input[name=report_params]').val(query);
				_object_edit_init('report_definition', dlg_title);
        $dialog.dialog('open');
			}
	);
};


var ajax_error_handler = function(jqXHR, textStatus, errorThrown){
	_error_dlg('error_handler status=' + textStatus + ' error=' + errorThrown);
};

var _error_dlg = function(txt){
	show_alert(_error_label, txt);
};

var _format_warnings = function(warnings){
	var rv='';
	if (Array.isArray(warnings)){
		for(var i=0; i < warnings.length; i++){
			rv += '<p><span class="error_msg">' + warnings[i] + '</span></p>';
		}
	}
	return rv;
};

var _load_active_failover_server_info = function(e) {
  var failover_id = e.data.id, callback = e.data.callback, ajaxController = e.data.ajaxController;

  if (!$('#active-failover-appliances-' + failover_id).length) {
    return;
  }

  $.ajax({
    url      : '/' + ajaxController + '/get_failover_server_info/' + failover_id,
    type     : 'POST',
    data     : { failover_id : failover_id },
    dataType : 'json',
    error    : ajax_error_handler,
    success  : function(rv, status, xhr){
      //TODO - MOVE ALL THIS INTO A DEFERRED OBJECT
      if (rv['is_error']){
        var errors = rv['errors'],
            err_msg = '';
        if (errors['_message_']){
          err_msg += '<p><span class="error_msg">' +  errors['_message_'] + '</span></p>';
        }
        if (Array.isArray(errors['_warnings_'])){
          err_msg += _format_warnings(errors['_warnings_']);
        }
        _error_dlg(err_msg);
      } else {
        rv.devices.forEach(function(item) {
          var row = $('#active-failover-appliances-' + failover_id + ' [data-server-id=' + item.server_id + ']');

          // change class to show proper status icon
          $(row).removeClass(row.data('current-status')).addClass(item.status).data('current-status', item.status);

          if (!item.worker_id) { item.worker_id = '-&nbsp;-'; }
          if (!item.cores) { item.cores = '-&nbsp;-'; }
          if (!item.ram) { item.ram = '-&nbsp;-'; }

          $('.col-worker', row).html(item.worker_id);
          $('.col-cores', row).html(item.cores);
          $('.col-ram', row).html(item.ram);
          $('.col-status', row).html(item.status_label);
        });

        if (typeof callback == 'function') {
          callback();
        }

        setTimeout(function() {
          $(document).trigger(e.type + '.' + e.namespace);
        }, 5000);
      }
    }
  });
}

function _s2sSaveStatusHandler(deferred) {
	var $container = $('.section_container'),
      onSuccess = function(event, settingsSummary) {
		var setting = settingsSummary['s2s_vpn'];
		if (setting.busy) {
			$container.one('failover_server_info_success', onSuccess);
		}
		else {
			deferred.resolve();
		}
	};
	$container.one('failover_server_info_success', onSuccess);
	$container.trigger('forceVirtualOfficePendingOperationsCheck');
}



function _server_status_update(failoverId, device){
  var $vm_pane = $('#failover_container' + failoverId + ' .vm-table [data-server-id=' + device.server_id + ']'),
      $vm_row = $vm_pane.filter('.vm-row');
	if ($vm_row.length === 0){
		if (typeof(console) != 'undefined'){
			console.info("couldn't find vm-row for serverId=" + device.server_id);
		}
		return;
	}

	//assign the actions to the appropriate row.
	$vm_row.data('actions', device.actions);

  //Update the Rendering label
	if( $vm_row.data('currentStatus') != device.status ) {
		$vm_row.removeClass( $vm_row.data('currentStatus') ).addClass( device.status ).data('currentStatus', device.status);
		$('.col-status .col-data', $vm_pane).html( device.status_label );
	}
	else if( $vm_row.data('currentStatus') === 'converting' ) {
		$('.col-status .col-data', $vm_pane).html( device.status_label );
	}

  //Update VNC info
	var $vm_vncsrv = $('.col-vncsrv .col-data', $vm_pane),
      $vm_vncpswd = $('.col-vncpswd .col-data', $vm_pane);
  if((device.status === 'running')
       && (typeof( device.vnc_info ) != 'undefined')) {
    $vm_vncsrv.html( device.vnc_info.srv );
    $vm_vncpswd.html( device.vnc_info.password );
  }
  else {
    $vm_vncsrv.html('-&nbsp;-');
    $vm_vncpswd.html('-&nbsp;-');
  }

  $('.col-cores .col-data', $vm_pane).html(
    ( device.cores ) ? device.cores : '-&nbsp;-'
  );
  $('.col-ram .col-data', $vm_pane).html(
    ( device.ram ) ? device.ram : '-&nbsp;-'
  );
  $('.col-restorepoint .col-data', $vm_pane).html(
    ( device.restorepoint ) ? device.restorepoint : '-&nbsp;-'
  );
}

var _file_browser = function(el){
  show_loading(browse_msg_loading);
	var id = el.getAttribute('_id');
	$.ajax({
	  url: '/appliance/file_browser_open/' + id,
	  dataType: 'script',
	  success: function (data) { $('#loading_box').dialog('destroy').remove(); if (data.length === 0) {show_alert(_error_label, browse_err_unreachable);} },
	  error: function () { $('#loading_box').dialog('destroy').remove(); show_alert(_error_label, browse_err_unreachable); }
	});
};

function killgenericpopout(){
	var active_row = $(".generic_list tr.activerow");
	active_row.find(".popout").hide();
	active_row.removeClass("activerow");
}

function create_popout(el) {
  var $el = $(el),
      $base_menu = $('<div class="popout"><div class="popoutitem" data-vm-action="details">' + _failover_vm_details_label + '</div></div>');
  $.each( $el.data('actions'), function(i, obj) {
    $('<div class="popoutitem" data-vm-action="' + obj.action + '">' + obj.label + '</div>').click( function(e){
      if (typeof window['_vm_action_' + obj.action] === 'function'){
        window['_vm_action_' + obj.action]( $(this).closest('.vm-row') );
      }
    }).appendTo( $base_menu );
  });
  $el.append( $base_menu );
}

// find the tab that contains the specified element, then remove it
function get_tab_index_for_element(id){
  var el = $("#" + id);
  while (true) {
    if (el.length === 0){
      return -1;
    }
    if (el.parent().attr('id') === 'tabs'){
      break;
    }
    el = el.parent();
  }

  return $('#tabs>div').index(el);
}

/* Closes subsection in the sidebar, currently used solely for DAS status
 * Saves a cookie of the form <user_id>:<das_history_id>,
 * which will prevent that particular status from reappearing for that user */
function close_box(self, cookie_key){
  $.cookie(cookie_key, true, {expires : 7, secure: true});
  $(self).parents('.subsection').slideUp('slow')
          .prev().animate({
            'padding-bottom' : 0,
            'border-bottom' : 0 }, 'slow');
}

function getHumanSize(size) {
  var sizePrefixes = ' KMGTPEZYXWVU';
  if (size <= 0) { return '0'; }

  var u = 0;
  do {
    size /= 1024;
    ++u;
  } while (size >= 1024);

  var decimals = (u > 2)? 1 : 0,
      d = Math.pow(10, decimals);
  size = parseInt(Math.max(size, 0.1) * d) / d;

  return size.toFixed(decimals).replace('.0', '') + ' ' + sizePrefixes.charAt(u).replace(' ', '') + 'B';
}

var $document = $(document);
$document.ready(function(){
  $document.on('keypress', refresh_handler);
  $document.on('click', killgenericpopout);
  $document.on('click', '.add-role', function(event){ _object_new(event, 'role'); });
  $document.on('click', '.add-version', function(event){ _object_new(event, 'version'); });
  $document.on('click', '.add-datacenter', function(event){ _object_new(event, 'datacenter'); });
  $document.on('click', '.add-user', function(event){ _object_new(event, 'user'); });
  $document.on('click', '.add-appliance', function(event){ _object_new(event, 'appliance'); });
  $document.on('click', '.add-feature', function(event){ _object_new(event, 'feature'); });
  $document.on('click', '.add-package', function(event){ _object_new(event, 'package'); });
  $document.on('click', '.add-marketing_model', function(event){ _object_new(event, 'marketing_model'); });
  $document.on('click', '.add-cloud_entitlement', function(event){ _object_new(event, 'cloud_entitlement'); });
  $document.on('click', '.add-reseller', function(event){ _object_new(event, 'reseller'); });
  $document.on('click', '.add-client', function(event){ _object_new(event, 'client'); });
  $document.on('click', '.add-notification', function(event){ _object_new(event, 'notification'); });
  $document.on('click', '.add-update_schedule', function(event){ _object_new(event, 'update_schedule'); });// not used

  $('#my_account').on('click', function(){ _edit_my_account(); });
  $('#feedback').on('click', show_feedback_dialog );
  $('#notification a').on('click', function(){ $('#notification').hide('slow', function(){ $('#notification').remove(); }); });

  if (popupNotifications.length > 0){
    $('.js-modal-mfa-box').hide();
    show_alert(_notification_dialog_title, popupNotifications.join('<br><hr><br>'));
  }

  $document.on('focus', '.edit_field', function(){
  	//make work for cases where the field is open ended
    var $this = $(this),
        $closestRow = $this.closest('.data_row');
  	if ($closestRow.length > 0){
      $closestRow.find('.tooltip').show();
  	}
  	else {
      $this.closest('.edit_item').find('.tooltip').show();
  	}
  });
  $document.on('blur', '.edit_field', function(){
    $(this).closest('.edit_item').find('.tooltip').hide();
  });

//  $("#tabs").on("tabsselect tabsload tabscreate tabsshow tabsadd tabsenable", adjust_help_link);
//
//  adjust_help_link();
//
	var reportPages = ['#offsite_report', '#onsite_report', '#stats_report', '#cloud_stats_report', '#fieldintel_report',
		'#auditor', '#backup_statistic_report', '#job_snapshot_report',
		'#notifications_report', '#usage_stats_report', '#version_history_report', '#replibit_usage_stats_report',
		'#replibit_d2c_usage_stats_report', '#replibit_appliance_summary_report', '#replibit_private_vault_summary_report',
		'#replibit_cloud_vault_summary_report', '#replibit_d2c_virtual_office_usage_summary_report'];
  $document.on('change', reportPages.join(' .dataTables_length select,') + ' .dataTables_length select', function(){
    $.cookie('report_records_shown', $(this).val(), { expires: 7, secure: true });
  });

  $document.on('change', "#umi_events_search", function(){
    $.cookie('umi_events_shown', $(this).val(), {secure: true});
  });

  $document.on('change', 'input[type="text"],textarea', function(){
    if (this.value) {
      this.value = this.value.trim();
    }
  });

  /** check for UI is outdated */
  var data_user_crc = $('.welcome').data('user-crc');
  $document.ajaxComplete( function(){
    var cookie_user_crc = $.cookie('user_crc');
    if( data_user_crc && cookie_user_crc && cookie_user_crc != data_user_crc ){
      document.location.href = '/';
    }
  });

  /** fix overlay in case of dialog is longer then viewport
   * TODO: check on modern jquery-ui */
  $document.on('dialogopen', '.axDialog', function(){
    $('.ui-widget-overlay').height( $document.outerHeight() );
  });


  (function(f,w){function m(){}function g(a,b){if(a){"object"===typeof a&&(a=[].slice.call(a));for(var c=0,d=a.length;c<d;c++)b.call(a,a[c],c)}}function v(a,b){var c=Object.prototype.toString.call(b).slice(8,-1);return b!==w&&null!==b&&c===a}function k(a){return v("Function",a)}function h(a){a=a||m;a._done||(a(),a._done=1)}function n(a){var b={};if("object"===typeof a)for(var c in a)a[c]&&(b={name:c,url:a[c]});else b=a.split("/"),b=b[b.length-1],c=b.indexOf("?"),b={name:-1!==c?b.substring(0,c):b,url:a};
  return(a=p[b.name])&&a.url===b.url?a:p[b.name]=b}function q(a){var a=a||p,b;for(b in a)if(a.hasOwnProperty(b)&&a[b].state!==r)return!1;return!0}function s(a,b){b=b||m;a.state===r?b():a.state===x?d.ready(a.name,b):a.state===y?a.onpreload.push(function(){s(a,b)}):(a.state=x,z(a,function(){a.state=r;b();g(l[a.name],function(a){h(a)});j&&q()&&g(l.ALL,function(a){h(a)})}))}function z(a,b){var b=b||m,c;/\.css[^\.]*$/.test(a.url)?(c=e.createElement("link"),c.type="text/"+(a.type||"css"),c.rel="stylesheet",
  c.href=a.url):(c=e.createElement("script"),c.type="text/"+(a.type||"javascript"),c.src=a.url);c.onload=c.onreadystatechange=function(a){a=a||f.event;if("load"===a.type||/loaded|complete/.test(c.readyState)&&(!e.documentMode||9>e.documentMode))c.onload=c.onreadystatechange=c.onerror=null,b()};c.onerror=function(){c.onload=c.onreadystatechange=c.onerror=null;b()};c.async=!1;c.defer=!1;var d=e.head||e.getElementsByTagName("head")[0];d.insertBefore(c,d.lastChild)}function i(){e.body?j||(j=!0,g(A,function(a){h(a)})):
  (f.clearTimeout(d.readyTimeout),d.readyTimeout=f.setTimeout(i,50))}function t(){e.addEventListener?(e.removeEventListener("DOMContentLoaded",t,!1),i()):"complete"===e.readyState&&(e.detachEvent("onreadystatechange",t),i())}var e=f.document,A=[],B=[],l={},p={},E="async"in e.createElement("script")||"MozAppearance"in e.documentElement.style||f.opera,C,j,D=f.head_conf&&f.head_conf.head||"head",d=f[D]=f[D]||function(){d.ready.apply(null,arguments)},y=1,x=3,r=4;d.load=E?function(){var a=arguments,b=a[a.length-
  1],c={};k(b)||(b=null);g(a,function(d,e){d!==b&&(d=n(d),c[d.name]=d,s(d,b&&e===a.length-2?function(){q(c)&&h(b)}:null))});return d}:function(){var a=arguments,b=[].slice.call(a,1),c=b[0];if(!C)return B.push(function(){d.load.apply(null,a)}),d;c?(g(b,function(a){if(!k(a)){var b=n(a);b.state===w&&(b.state=y,b.onpreload=[],z({url:b.url,type:"cache"},function(){b.state=2;g(b.onpreload,function(a){a.call()})}))}}),s(n(a[0]),k(c)?c:function(){d.load.apply(null,b)})):s(n(a[0]));return d};d.js=d.load;d.test=
  function(a,b,c,e){a="object"===typeof a?a:{test:a,success:b?v("Array",b)?b:[b]:!1,failure:c?v("Array",c)?c:[c]:!1,callback:e||m};(b=!!a.test)&&a.success?(a.success.push(a.callback),d.load.apply(null,a.success)):!b&&a.failure?(a.failure.push(a.callback),d.load.apply(null,a.failure)):e();return d};d.ready=function(a,b){if(a===e)return j?h(b):A.push(b),d;k(a)&&(b=a,a="ALL");if("string"!==typeof a||!k(b))return d;var c=p[a];if(c&&c.state===r||"ALL"===a&&q()&&j)return h(b),d;(c=l[a])?c.push(b):l[a]=[b];
  return d};d.ready(e,function(){q()&&g(l.ALL,function(a){h(a)});d.feature&&d.feature("domloaded",!0)});if("complete"===e.readyState)i();else if(e.addEventListener)e.addEventListener("DOMContentLoaded",t,!1),f.addEventListener("load",i,!1);else{e.attachEvent("onreadystatechange",t);f.attachEvent("onload",i);var u=!1;try{u=null==f.frameElement&&e.documentElement}catch(F){}u&&u.doScroll&&function b(){if(!j){try{u.doScroll("left")}catch(c){f.clearTimeout(d.readyTimeout);d.readyTimeout=f.setTimeout(b,50);
  return}i()}}()}setTimeout(function(){C=!0;g(B,function(b){b()})},300)})(window);

  head.js("/resources/js/angular-bundle.js", function(){

    window.angularnullapp = angular.module("angularnullapp", []);

    var dialogapp = angular.module("dialogApp", []);

    dialogapp.directive("toggleAxdialog", function(){
      return {
        restrict : "A",
        scope: {},
        link : function(scope, element, attrs){
          element.click(function(){
            angular.element($("[dialogname=" + attrs.toggleAxdialog + "]")[0]).scope().toggleDialog();
          });
        }
      }
    });

    dialogapp.directive("axdialog", function(){
      return {
        restrict: "E",
        scope: {
          dialogtitle : "@",
          onopen      : "&"
        },
        transclude: true,
        controller: function($scope, $element){

          $scope.dialogState = "";

          $scope.openDialog = function(){
            $element.show();
            $scope.dialogState = "open";

            $scope.onopen();

          }

          $scope.closeDialog = function(){
            $element.hide();
            $scope.dialogState = "closed";
          }

          $scope.$parent.toggleDialog = function(){
            $scope.dialogState == "open" ? $scope.closeDialog() : $scope.openDialog();
          }

        },

        link : function(scope, element, attrs){

          scope.closeDialog();
          scope.showmodal = attrs.showmodal || true;

          element.find(".closeDialogOnClick").click(function(){
            scope.closeDialog();
          });

        },
        templateUrl: "/template/axdialog"
      }
    });

    var progressPieApp = angular.module('progressPieApp', []);
    progressPieApp.directive("progresspie", function(){

      var controller = ['$scope', function($scope) {
        $scope.progressPieShow = false;

        var value = $scope.percent,
            smallPie = 0,
            bigPie = 0,
            rotate = function(rotateVal){
          return {
            'transform': rotateVal
          };
        };

        if( value > 0) {
            $scope.smallPieShow = true;

            if (value <= 50) {
                smallPie = value;
            } else {
                smallPie = 50;
                bigPie = value - 50;
                $scope.smallPieShow = true;
                $scope.bigPieShow = true;
            }

            $scope.smallPie = rotate('rotate(' + smallPie*3.6 + 'deg)');
            $scope.bigPie = rotate('rotate(' + bigPie*3.6 + 'deg)');
            $scope.progressPieShow = true;
        }
      }];

      return{
        restrict: "E",
        scope: {
            percent: "@percent"
        },
        controller: controller,
        templateUrl: "/template/progress-pie"
      };
    });

    // angular bootstrapping
    setInterval(function(){
      $("[angular-bootstrapapp],[toggle-axdialog]").each(function(i, elem){
        if(!elem.__angular_bs){
          elem.__angular_bs = true;
          angular.bootstrap(elem, [$(elem).attr("angular-bootstrapapp")]);
        }
      });
    }, 200);


  });

  function getClientTimezoneOffset() {
    return new Date().getTimezoneOffset();
  }

  function isDSTTime() {
    return new Date().isDST();
  }

  var clientTimezoneOffset,
      isClientOnDSTTime,
      timezoneUpdateTimeoutId;

  (function pollClientTimezoneOffset () {
    var newClientTimezoneOffset = getClientTimezoneOffset(),
        newIsClientOnDSTTime = isDSTTime();
    if ((newClientTimezoneOffset != clientTimezoneOffset) ||
        (newIsClientOnDSTTime != isClientOnDSTTime)) {
      clientTimezoneOffset = newClientTimezoneOffset;
      isClientOnDSTTime = newIsClientOnDSTTime;

      $.ajax({
        url: '/session/set_user_timezone/',
        type: 'POST',
        data: { offset: clientTimezoneOffset, is_dst: (+isClientOnDSTTime) }
      });
    }

    timezoneUpdateTimeoutId = setTimeout(pollClientTimezoneOffset, 60000);
  })();

});

// TODO: refactor this code to use separate functions instead of extending of Date prototype
// Moved from recover-flow-gen2.js during refactoring
Date.prototype.getMonthName = function () {
  return months_names[this.getMonth()];
};
Date.prototype.getMonthNameShort = function () {
  return months_names_short[this.getMonth()];
};
Date.prototype.getDatePoint = function () {
  //return date in format yyyymmdd
  return $.datepicker.formatDate('yymmdd', this);
};
Date.prototype.getFormattedDatePoint = function () {
  //return date in format MM d, yy
  return $.datepicker.formatDate("MM d, yy", this);
};
Date.prototype.getDownloadDate = function () {
  //return date in format yyyy-mm-dd hh-mm-ss
  var _hh = this.getHours().toString().length > 1 ? this.getHours() : '0' + this.getHours(),
      _mm = this.getMinutes().toString().length > 1 ? this.getMinutes() : '0' + this.getMinutes(),
      _ss = this.getSeconds().toString().length > 1 ? this.getSeconds() : '0' + this.getSeconds();
  return $.datepicker.formatDate('yy-mm-dd-' + _hh + '-' + _mm + '-' + _ss, this);
};
